import { outdent } from "outdent";
import { FiBell } from "@react-icons/all-files/fi/FiBell";
import * as React from 'react';
export default {
  outdent,
  FiBell,
  React
};